import { Skeleton } from '@comeon/ui';
import styled from 'styled-components';

export const CarouselItem = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	height: 190px;
	width: 340px;
	border-radius: var(--base-radius-large);
	background-color: var(--main-surface-1);
	padding: 12px;
	overflow: hidden;
`;

const SkeletonWrapper = styled(CarouselItem)`
	padding: 0;
`;

export const CarouselSkeleton = () => (
	<SkeletonWrapper>
		<Skeleton height="100%" width="100%" />
	</SkeletonWrapper>
);
